import { render, staticRenderFns } from "./editDiary.vue?vue&type=template&id=35b28f56&scoped=true&"
import script from "./editDiary.vue?vue&type=script&lang=js&"
export * from "./editDiary.vue?vue&type=script&lang=js&"
import style0 from "./editDiary.vue?vue&type=style&index=0&id=35b28f56&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b28f56",
  null
  
)

export default component.exports